import { isAbsoluteEmpty } from 'ziphy-web-shared/basic/helpers/other';
const getNestedValue = (obj, path) => {
    if (path === '__self__')
        return obj;
    if (typeof obj !== 'object' || obj === null)
        return undefined;
    return path.split('.').reduce((acc, key) => acc === null || acc === void 0 ? void 0 : acc[key], obj);
};
export const checkCondition = (target, condition) => {
    if ('and' in condition) {
        return condition.and.every((subCond) => checkCondition(target, subCond));
    }
    if ('or' in condition) {
        return condition.or.some((subCond) => checkCondition(target, subCond));
    }
    if ('not' in condition) {
        return !checkCondition(target, condition.not);
    }
    if ('equals' in condition) {
        const { property, value } = condition.equals;
        return getNestedValue(target, property) === value;
    }
    if ('in' in condition) {
        const { property, value } = condition.in;
        return value.includes(getNestedValue(target, property));
    }
    if ('exists' in condition) {
        const { property, value } = condition.exists;
        return !isAbsoluteEmpty(getNestedValue(target, property)) === value;
    }
    return false;
};
